"use client";

import { c as _c } from "react/compiler-runtime";
import { useRouter } from "next/navigation";
import React, { useEffect, useRef, useState } from "react";
import { BinIcon, Button, ButtonSize, ButtonVariant, Input, Progress, ProgressColor, Text, TextColor, TextSize, TextVariant, TextWeight } from "../../components";
import { useMatchBreakpoints } from "../../hooks";
import { FeaturedProducts } from "../FeaturedProducts";
import { ProductListItem } from "../ProductListItem";
const CartPage = t0 => {
  const $ = _c(72);
  const {
    cart,
    loadingCart,
    updateCart,
    loadingProductAttributes,
    deleteProductFromCart,
    addVoucherToCart,
    clearErrors,
    loadingModifyVoucher,
    featuredProducts,
    loadingFeaturedProducts,
    idCarrier
  } = t0;
  const [voucherCode, setVoucherCode] = useState("");
  const [parentWidth, setParentWidth] = useState(0);
  const parentRef = useRef(null);
  const router = useRouter();
  const {
    isXs,
    isSm,
    isMd
  } = useMatchBreakpoints();
  const isMobile = isXs || isSm || isMd;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      const updateWidth = () => {
        if (parentRef.current) {
          setParentWidth(parentRef.current.offsetWidth);
        }
      };
      updateWidth();
      window.addEventListener("resize", updateWidth);
      return () => {
        window.removeEventListener("resize", updateWidth);
      };
    };
    t2 = [];
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  useEffect(t1, t2);
  let t3;
  if ($[2] !== cart.errors[0] || $[3] !== cart.errors.length) {
    t3 = cart.errors.length > 0 && <div className="w-full flex justify-center items-center py-2 bg-red-100 gap-4"><Progress color={ProgressColor.ERROR_500} typeButton={true} /><Text text={cart.errors[0]} color={TextColor.ERROR_500} fontSize={TextSize.S} /></div>;
    $[2] = cart.errors[0];
    $[3] = cart.errors.length;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const t4 = isMobile ? TextVariant.H6 : TextVariant.H4;
  let t5;
  if ($[5] !== t4) {
    t5 = <div className="flex justify-center md:justify-start"><Text text="Koszyk" variant={t4} weight={TextWeight.SEMIBOLD} /></div>;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== cart.products || $[8] !== deleteProductFromCart || $[9] !== loadingProductAttributes || $[10] !== updateCart) {
    t6 = cart.products.length > 0 && cart.products.map(product => <ProductListItem key={product.idProduct || product.reference} product={product} showQuantityControls={true} showRemoveButton={true} onQuantityChange={updateCart} loading={loadingProductAttributes[Number(product.idProductAttribute)]} deleteProductFromCart={deleteProductFromCart} productUrlAvailable={true} />);
    $[7] = cart.products;
    $[8] = deleteProductFromCart;
    $[9] = loadingProductAttributes;
    $[10] = updateCart;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t6) {
    t7 = <div className="flex flex-col mt-2 md:mt-6 lg:pr-8 gap-1">{t6}</div>;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== featuredProducts || $[15] !== isMobile || $[16] !== loadingFeaturedProducts || $[17] !== parentWidth) {
    t8 = !isMobile && featuredProducts.length > 0 && <div style={{
      width: parentWidth
    }} className="lg:pr-8"><FeaturedProducts products={featuredProducts} isLoading={loadingFeaturedProducts} title={"Inni kupili tak\u017Ce"} smallTitle={true} productView={true} /></div>;
    $[14] = featuredProducts;
    $[15] = isMobile;
    $[16] = loadingFeaturedProducts;
    $[17] = parentWidth;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== t5 || $[20] !== t7 || $[21] !== t8) {
    t9 = <div ref={parentRef} className="px-2 md:px-0 py-4 md:py-8 flex flex-col order-1">{t5}{t7}{t8}</div>;
    $[19] = t5;
    $[20] = t7;
    $[21] = t8;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <Text text="Podsumowanie" variant={TextVariant.H6} weight={TextWeight.SEMIBOLD} />;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  let t11;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <Text text={"Cena produkt\xF3w"} weight={TextWeight.SEMIBOLD} />;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  let t13;
  if ($[25] !== cart.subtotals || $[26] !== loadingCart) {
    t12 = <div className="flex justify-between">{t11}{loadingCart ? <div className="h-6 w-20 bg-gray-200 rounded animate-pulse" /> : <Text text={cart.subtotals.products.value} />}</div>;
    t13 = cart.subtotals?.discounts && cart.subtotals.discounts.amount !== 0 && <div className="flex justify-between"><Text text="Rabat" weight={TextWeight.SEMIBOLD} />{loadingCart ? <div className="h-6 w-20 bg-gray-200 rounded animate-pulse" /> : <Text text={cart.subtotals.discounts.value} color={TextColor.SPECIAL_700} weight={TextWeight.SEMIBOLD} className="bg-green-100" />}</div>;
    $[25] = cart.subtotals;
    $[26] = loadingCart;
    $[27] = t12;
    $[28] = t13;
  } else {
    t12 = $[27];
    t13 = $[28];
  }
  let t14;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <Text text={"Wysy\u0142ka"} weight={TextWeight.SEMIBOLD} />;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  let t15;
  if ($[30] !== cart.subtotals || $[31] !== idCarrier || $[32] !== loadingCart) {
    t15 = <div className="flex justify-between">{t14}{loadingCart ? <div className="h-6 w-20 bg-gray-200 rounded animate-pulse" /> : <Text text={cart.subtotals.shipping.value ? `${cart.subtotals.shipping.value !== "Za darmo!" && idCarrier === null ? "od " : ""}${cart.subtotals.shipping.value}` : "od 0,00 z\u0142"} />}</div>;
    $[30] = cart.subtotals;
    $[31] = idCarrier;
    $[32] = loadingCart;
    $[33] = t15;
  } else {
    t15 = $[33];
  }
  let t16;
  if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <Text text="Razem" weight={TextWeight.BOLD} />;
    $[34] = t16;
  } else {
    t16 = $[34];
  }
  let t17;
  if ($[35] !== cart.totals || $[36] !== loadingCart) {
    t17 = <div className="flex justify-between border-t pt-4 mt-4">{t16}{loadingCart ? <div className="h-6 w-20 bg-gray-200 rounded animate-pulse" /> : <Text text={cart.totals.total.value} weight={TextWeight.BOLD} />}</div>;
    $[35] = cart.totals;
    $[36] = loadingCart;
    $[37] = t17;
  } else {
    t17 = $[37];
  }
  let t18;
  if ($[38] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = e => setVoucherCode(e.target.value);
    $[38] = t18;
  } else {
    t18 = $[38];
  }
  let t19;
  if ($[39] !== voucherCode) {
    t19 = <Input id="coupon" name="coupon" placeholder="Wpisz kod" icon={true} className="!w-full" value={voucherCode} onChange={t18} />;
    $[39] = voucherCode;
    $[40] = t19;
  } else {
    t19 = $[40];
  }
  let t20;
  if ($[41] !== addVoucherToCart || $[42] !== clearErrors || $[43] !== voucherCode) {
    t20 = () => {
      addVoucherToCart(voucherCode, "add");
      setVoucherCode("");
      setTimeout(() => {
        clearErrors();
      }, 5000);
    };
    $[41] = addVoucherToCart;
    $[42] = clearErrors;
    $[43] = voucherCode;
    $[44] = t20;
  } else {
    t20 = $[44];
  }
  let t21;
  if ($[45] !== loadingModifyVoucher || $[46] !== t20) {
    t21 = <Button text="Dodaj" variant={ButtonVariant.SECONDARY} size={ButtonSize.XS} loading={loadingModifyVoucher} disabled={loadingModifyVoucher} onClick={t20} />;
    $[45] = loadingModifyVoucher;
    $[46] = t20;
    $[47] = t21;
  } else {
    t21 = $[47];
  }
  let t22;
  if ($[48] !== t19 || $[49] !== t21) {
    t22 = <div className="flex justify-between mt-8 gap-4 relative mb-2">{t19}{t21}</div>;
    $[48] = t19;
    $[49] = t21;
    $[50] = t22;
  } else {
    t22 = $[50];
  }
  let t23;
  if ($[51] !== addVoucherToCart || $[52] !== cart.vouchers.added || $[53] !== cart.vouchers.allowed) {
    t23 = cart.vouchers.allowed > 0 && Object.values(cart.vouchers.added).map(voucher => <div key={voucher.idCartRule} className="flex gap-2 justify-between"><div className="flex flex-col"><Text text={voucher.code} /><Text text={voucher.name} color={TextColor.GRAYSCALE_500} fontSize={TextSize.XS} /></div><div className="cursor-pointer hover:text-red-800 transition-colors duration-300" onClick={() => {
        addVoucherToCart(voucher.code, "delete", Number(voucher.idCartRule));
      }}><BinIcon /></div></div>);
    $[51] = addVoucherToCart;
    $[52] = cart.vouchers.added;
    $[53] = cart.vouchers.allowed;
    $[54] = t23;
  } else {
    t23 = $[54];
  }
  let t24;
  if ($[55] === Symbol.for("react.memo_cache_sentinel")) {
    t24 = <div className="flex justify-between my-4 px-4 text-center"><Text text={"Produkty w koszyku nie podlegaj\u0105 rezerwacji! Aby zarezerwowa\u0107 produkt z\u0142\xF3\u017C zam\xF3wienie."} color={TextColor.GRAYSCALE_500} fontSize={TextSize.XS} /></div>;
    $[55] = t24;
  } else {
    t24 = $[55];
  }
  let t25;
  if ($[56] !== router) {
    t25 = <Button text={"Przejd\u017A do kasy"} variant={ButtonVariant.PRIMARY} className="!w-full" onClick={() => {
      router.push("/zamowienie");
    }} />;
    $[56] = router;
    $[57] = t25;
  } else {
    t25 = $[57];
  }
  let t26;
  if ($[58] !== t12 || $[59] !== t13 || $[60] !== t15 || $[61] !== t17 || $[62] !== t22 || $[63] !== t23 || $[64] !== t25) {
    t26 = <div className="p-8 lg:p-12 bg-gray-50 order-2">{t10}<div className="flex flex-col gap-4 mt-6">{t12}{t13}{t15}{t17}{t22}{t23}{t24}{t25}</div></div>;
    $[58] = t12;
    $[59] = t13;
    $[60] = t15;
    $[61] = t17;
    $[62] = t22;
    $[63] = t23;
    $[64] = t25;
    $[65] = t26;
  } else {
    t26 = $[65];
  }
  let t27;
  if ($[66] !== t26 || $[67] !== t9) {
    t27 = <div className="grid lg:grid-cols-[1fr_480px] grid-cols-1 h-[calc(100%-37px)]">{t9}{t26}</div>;
    $[66] = t26;
    $[67] = t9;
    $[68] = t27;
  } else {
    t27 = $[68];
  }
  let t28;
  if ($[69] !== t27 || $[70] !== t3) {
    t28 = <div className="relative w-full max-w-screen-2xl mx-auto h-[calc(100%-37px)] pl-0 md:pl-4 2xl:pl-0 ">{t3}{t27}</div>;
    $[69] = t27;
    $[70] = t3;
    $[71] = t28;
  } else {
    t28 = $[71];
  }
  return t28;
};
export default CartPage;